import Icon, { type IconString } from '2-core-elements/Icon/Icon';

export type BadgeProps = {
    label: string;
    skin?: 'primary' | 'neutral' | 'success' | 'error' | 'warning' | 'info' | 'safety-alert';
    variant?: 'bold' | 'subtle' | 'outline';
    size?: 'sm' | 'md' | 'lg';
    prefixIcon?: IconString;
    id?: string;
};

const Chip = ({ skin = 'primary', variant = 'bold', label, size = 'md', id, prefixIcon }: BadgeProps): JSX.Element => {
    return (
        <div className={`badge badge-${skin} badge-${variant} badge-${size}`} id={id}>
            {prefixIcon && <Icon icon={prefixIcon} />}
            {label}
        </div>
    );
};

export default Chip;
